import { render, staticRenderFns } from "./index-gdqcdzaz.vue?vue&type=template&id=3c86fa08&scoped=true&"
import script from "./index-gdqcdzaz.vue?vue&type=script&lang=js&"
export * from "./index-gdqcdzaz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c86fa08",
  null
  
)

export default component.exports